module.exports = __webpack_public_path__ + "img/dcfl05.326eb9c3.png";